import { useState } from "react";
import { CheckPicker, CheckPickerProps } from "rsuite";

interface CheckPickerSelectFilterProps extends CheckPickerProps {
    onSelectFilter: (data: any[]) => void;
}

const CheckPickerSelectFilter = (props: CheckPickerSelectFilterProps) => {
    const [errorSearch, setErrorSearch] = useState('');

    const handleSelectAllFiltered = () => {
        const filteredValues = props.data
            .filter(item =>
                !errorSearch ||
                String(item.label).toLowerCase().includes(errorSearch.toLowerCase())
            )
            .map(item => item.value);

        const newErrorsSelection = Array.from(new Set([...(props.value || []), ...filteredValues]));
        props.onSelectFilter(newErrorsSelection);
    };

    return (
        <CheckPicker
            {...props}
            onSearch={(keyword, e) => {
                setErrorSearch(keyword)
                props.onSearch?.(keyword, e);
            }}
            onClose={() => {
                setErrorSearch('');
                props.onClose?.();
            }}
            renderMenu={(menu) => {
                if (errorSearch && errorSearch.trim() !== '') {
                    return (
                        <div>
                            <div style={{
                                padding: '0px 12px 4px',
                                borderBottom: '1px solid #e5e5e5',
                            }}>
                                <button
                                    type="button"
                                    className="rs-btn rs-btn-link rs-btn-xs"
                                    onClick={handleSelectAllFiltered}
                                    style={{
                                        padding: 0,
                                        fontWeight: 'bold'
                                    }}
                                >
                                    Selecionar resultados da busca
                                </button>
                            </div>
                            {menu}
                        </div>
                    );
                }

                return menu;
            }}
        />
    )
}

export { CheckPickerSelectFilter };
